
export default {
    data() {
        return {};
    },
    methods: {
        replaceNode(oldNode, node) {
            if (((oldNode.id && node.id) && (oldNode.id === node.id))
                || ((oldNode.ref && node.ref) && (oldNode.ref === node.ref))) {
                // if root node
                return node.children ? node.children : [node];
            }

            if (oldNode && oldNode.children) {
                return oldNode.children.map(n => {
                    if (n.ref === node.ref) {
                        // eslint-disable-next-line no-param-reassign
                        n = { ...node };
                        return n;
                    }
                    if (n.children && n.children.length > 0) {
                        return { ...n, children: this.replaceNode(n, node) };
                    }
                    return n;
                });
            }
            return [node];
        },
        flatMapAllNodes(nodes) {
            return nodes.flatMap(n => {
                if (n.children) {
                    return this.flatMapAllNodes(n.children).concat(n);
                }
                return n;
            });
        },
        setChildrenShowStatus(node, oldNode) {
            if (node.children) {
                // eslint-disable-next-line no-param-reassign
                node.children = [...node.children.map(n => {
                    if (n.children) this.setChildrenShowStatus(n, oldNode);
                    const element = oldNode.find(o => o.ref === n.ref);
                    return { ...n, showChildren: element ? element.showChildren : false };
                })];
            }
            const element = oldNode.find(o => o.ref === node.ref);
            return { ...node, showChildren: element ? element.showChildren : false };
        },
        mapChildren(children) {
            return children.map(node => ({
                ...node,
                children: node.children ? this.mapChildren(node.children) : undefined,
                showChildren: node.showChildren || false,
            }));
        },

    },
};
